import React, { useEffect } from 'react'
import { BrowserRouter as Router, Route, Routes, useLocation, Navigate } from 'react-router-dom';
import AllProjects from '../components/AllProjects';
import Home from "../components/Home";
import ProjectDetails from '../components/ProjectDetails';
import AdminLogin from '../admin/AdminLogin';
import ForgotPassword from '../admin/ForgotPassword';
import ResetPassword from '../admin/ResetPassword';
import AdminDashboard from '../admin/AdminDashboard';
import ProjectList from '../admin/ProjectList';
import ProjectForm from '../admin/ProjectForm';
import ManageSections from '../admin/ManageSections';
import ManageResume from '../admin/ManageResume';
import ManageSkills from '../admin/ManageSkills';
import ManageHero from '../admin/ManageHero';
import ManageServices from '../admin/ManageServices';
import { trackVisit } from '../api/api';

// Must be inside <Router> to use useLocation()
function VisitorTracker() {
  const location = useLocation();
  useEffect(() => {
    // Don't count admin visits — only real portfolio visitors
    if (!location.pathname.startsWith('/admin')) {
      trackVisit(location.pathname).catch(() => {});
    }
  }, [location.pathname]);
  return null;
}

// Router guard to protect admin routes
const AdminRoute = ({ children }) => {
  const userInfo = JSON.parse(localStorage.getItem('userInfo'));
  if (!userInfo || !userInfo.isAdmin) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
};

const RoutesComponent = () => {
  return (
    <div>
      <Router>
        <VisitorTracker />
        <Routes>
          <Route path="/" element={<Home></Home>} />
          <Route path="/projects" element={<AllProjects />} />
          <Route path="/project-details/:id" element={<ProjectDetails></ProjectDetails>} />

          {/* Admin Routes */}
          <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/forgot-password" element={<ForgotPassword />} />
          <Route path="/admin/reset-password/:token" element={<ResetPassword />} />
          <Route path="/admin/dashboard" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
          <Route path="/admin/projects" element={<AdminRoute><ProjectList /></AdminRoute>} />
          <Route path="/admin/projects/add" element={<AdminRoute><ProjectForm /></AdminRoute>} />
          <Route path="/admin/projects/edit/:id" element={<AdminRoute><ProjectForm /></AdminRoute>} />
          <Route path="/admin/sections" element={<AdminRoute><ManageSections /></AdminRoute>} />
          <Route path="/admin/resume" element={<AdminRoute><ManageResume /></AdminRoute>} />
          <Route path="/admin/skills" element={<AdminRoute><ManageSkills /></AdminRoute>} />
          <Route path="/admin/hero" element={<AdminRoute><ManageHero /></AdminRoute>} />
          <Route path="/admin/services" element={<AdminRoute><ManageServices /></AdminRoute>} />
        </Routes>
      </Router></div>
  )
}

export default RoutesComponent